<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
	<bp-modal-header header class="font-semibold" [title]="'swap_successful' | translate">
		<a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div content>
		<div class="success-content-inner">
			<img class="success-image" src="/assets/images/success.svg" [alt]="'swap_successful' | translate" />
			<div class="success-headline mb-15">{{ "swap_successful" | translate }}</div>
			<div class="pb-80">
				<p class="swap-success-text description-text translation-helper">
					{{ swapType + "_pending_message" | translate }}
				</p>
				<!-- Vision info -->
				@if ((stakingVm$ | async) && showVisionWarning) {
					<p class="swap-success-text">
						{{
							"auto_staking_trade_success_vision_warning"
								| translate: [targetAsset?.getName(), targetAsset?.getSymbol()]
						}}
					</p>
				}
			</div>
		</div>
		@let visionId = visionId$ | async;
		@let isUkUser = isUkUser$ | async;
		@if (
			((visionFeeFlag$ | async) && !isUkUser &&
				visionFeeTokenCollection?.feeDiscount &&
					(visionFeeTokenCollection?.eligibleForVsn ||
						visionId.getId() === targetAsset?.getId() ||
						visionId.getId() === sourceAsset?.getId()) &&
				visionFeeTokenCollection?.globalOptIn === false) ||
			(visionFeeTokenCollection?.globalOptIn && visionFeeTokenCollection?.visionFeeDetail?.hasEnoughFunds === false)
		) {
			<div class="swap-vision-banner-container">
				<mo-success-vision-component
					[feeAmount]="visionFeeTokenCollection?.feeDiscount"
					[bannerState]="
						!visionFeeTokenCollection?.globalOptIn
							? MoSuccessVisionBannerState.VISIONFEENOTACTIVE
							: MoSuccessVisionBannerState.OPTEDININSUFFICIENTFUNDS
					"
					(click)="handleBannerClick()">
				</mo-success-vision-component>
			</div>
		}
		<div class="text-center">
			<button (click)="goToPortfolio()" class="btn btn-primary btn-success-modal" type="button">
				<strong>{{ "go_to_portfolio" | translate }}</strong>
			</button>
		</div>
	</div>
</success-screen>
